import { useFormikContext } from 'formik'
import { useEffect } from 'react'
import { useFormContext } from './form-context'

const FormWrapper = ({ children }: { children: ReactElement }) => {
  const { setDirty } = useFormContext()
  const { dirty } = useFormikContext()

  useEffect(() => {
    setDirty(dirty)
  }, [dirty, setDirty])

  return children
}
export default FormWrapper
